import React from 'react';
import { styled } from '@linaria/react';
import { Button } from '@vio/atlas/Button';
import { Divider } from '@vio/atlas/Divider';
import { NoStyleButton } from '@vio/atlas/helpers/NoStyleButton';
import { Icon } from '@vio/atlas/Icon';
import { Text } from '@vio/atlas/Text';
import { cssTheme } from '@vio/atlas/themes';
import { ThemeType } from 'types/Theme';
import FormattedMessageWrapper from '@daedalus/core/src/localization/components/FormattedMessage';
import { FilterDisplayContainerProps } from './FilterDisplayContainer';
const Flex = /*#__PURE__*/styled('div')({
  name: "Flex",
  class: "f18j4r8",
  propsAsIs: false
});
const PopoverHeader = /*#__PURE__*/styled('div')({
  name: "PopoverHeader",
  class: "p1lhq97w",
  propsAsIs: false
});
const Nothing: React.FC = ({
  children
}) => <>{children}</>;
const OverlayHeader = /*#__PURE__*/styled('div')({
  name: "OverlayHeader",
  class: "oiq8req",
  propsAsIs: false
});
const _exp5 = /*#__PURE__*/() => Text;
const Subtitle = /*#__PURE__*/styled(_exp5())({
  name: "Subtitle",
  class: "s102h5jm",
  propsAsIs: true
});
const PopoverTitle = /*#__PURE__*/styled('span')({
  name: "PopoverTitle",
  class: "p11dsxm2",
  propsAsIs: false
});
const OverlayTitle = /*#__PURE__*/styled('span')({
  name: "OverlayTitle",
  class: "oupeqzu",
  propsAsIs: false
});
const _exp11 = /*#__PURE__*/() => ({
  hasHorizontalPadding
}) => hasHorizontalPadding ? cssTheme.layout.spacing.s600 : 0;
const _exp12 = /*#__PURE__*/() => ({
  paddingBottom
}) => cssTheme.layout.spacing[paddingBottom];
const ChildrenWrapper = /*#__PURE__*/styled('div')({
  name: "ChildrenWrapper",
  class: "c1csmp4l",
  propsAsIs: false,
  vars: {
    "c1csmp4l-0": [_exp11()],
    "c1csmp4l-1": [_exp12()]
  }
});
const Footer = /*#__PURE__*/styled('div')({
  name: "Footer",
  class: "fg2g6a2",
  propsAsIs: false
});
const _exp16 = /*#__PURE__*/() => NoStyleButton;
const PopoverCloseButton = /*#__PURE__*/styled(_exp16())({
  name: "PopoverCloseButton",
  class: "p1wzk1dy",
  propsAsIs: true
});
const _exp19 = /*#__PURE__*/() => NoStyleButton;
const OverlayCloseButton = /*#__PURE__*/styled(_exp19())({
  name: "OverlayCloseButton",
  class: "o1i9ivfl",
  propsAsIs: true
});
type FilterDisplayContentProps = Pick<FilterDisplayContainerProps, 'title' | 'subtitle' | 'children' | 'onClose' | 'onClear' | 'onApply' | 'type' | 'paddingBottom' | 'dataId'>;
export const FilterDisplayContent: React.FC<FilterDisplayContentProps> = ({
  title,
  dataId,
  subtitle,
  children,
  onClose,
  onClear,
  onApply,
  type,
  paddingBottom
}) => {
  const Header = type === 'overlay' ? OverlayHeader : PopoverHeader;
  const Title = type === 'overlay' ? OverlayTitle : PopoverTitle;
  const TitleWrapper = type === 'overlay' ? Nothing : Flex;
  const CloseButton = type === 'overlay' ? OverlayCloseButton : PopoverCloseButton;
  return <div>
      <Header>
        <TitleWrapper>
          <Title>{title}</Title>
          <CloseButton onClick={onClose}>
            <Icon name="Close" />
          </CloseButton>
        </TitleWrapper>

        {subtitle && <Subtitle variant="bodyS" colorPath="content.neutral.c600">
            {subtitle}
          </Subtitle>}
      </Header>
      <ChildrenWrapper hasHorizontalPadding={type === 'popover'} paddingBottom={paddingBottom}>
        {children}
      </ChildrenWrapper>
      <Divider />
      <Footer data-id={`${dataId}Buttons`}>
        <Button dataId="clearFiltersButton" onClick={onClear} variant="secondary">
          <FormattedMessageWrapper id="clear" defaultMessage="Clear" />
        </Button>
        <Button dataId="applyFiltersButton" onClick={onApply}>
          <FormattedMessageWrapper id="apply" defaultMessage="Apply" />
        </Button>
      </Footer>
    </div>;
};

require("./FilterDisplayContent.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./FilterDisplayContent.tsx");